import React from "react";
import PropTypes from "prop-types";
import { InputText, Label } from "../../../../components/Inputs";

function ADWorkplaceTaskForm({
  className = "",
  model = {}
}) {
  console.log("ADWorkplaceTaskForm() model:", model);
  const { ngumUserId, name: workplace, userData } = model;
  let vfEmail = (<>&nbsp;</>);
  if (userData && userData.vf_email) {
    vfEmail = userData.vf_email;
  }
  let vbgFlag = (<>&nbsp;</>);
  let justification = (<>&nbsp;</>);
  switch (workplace.toLowerCase()) {
    case "deutschland":
      vbgFlag = "VBG-CSC-DE,VBG-CSC-EU";
      justification = "Anwender mit Arbeitsort in Deutschland";
      break;
    case "europa":
      vbgFlag = "VBG-CSC-EU";
      justification = "Anwender mit Arbeitsort innerhalb der EU";
      break;
    case "außerhalb europa":
      justification = "Arbeitsort des Mitarbeiters befindet sich außerhalb von Europa";
      break;
  }
  return (
    <div className={className}>
      <div className="pad-top- form-group-item">
        <Label>{`User Login`}</Label>
        <InputText
          className="w3-block w3-border pad"
          value={ngumUserId || (<>&nbsp;</>)}
          readonly
        />
      </div>
      <div className="pad-top form-group-item">
        <Label>{`Vodafone E-Mail Adresse`}</Label>
        <InputText
          className="w3-block w3-border pad"
          value={vfEmail}
          readonly
        />
      </div>
      <div className="pad-top form-group-item">
        <Label>{`VBG_CSC_FLAG`}</Label>
        <InputText
          className="w3-block w3-border pad"
          value={vbgFlag}
          readonly
        />
      </div>
      <div className="pad-top form-group-item">
        <Label>{`Business Justification`}</Label>
        <InputText
          className="w3-block w3-border pad"
          value={justification}
          readonly
        />
      </div>
    </div>
  );
}

ADWorkplaceTaskForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({
    name: PropTypes.string,
    ngumUserId: PropTypes.string,
    userData: PropTypes.shape({
      vf_email: PropTypes.string,
    }),
  }),
};

export default React.forwardRef((props, ref) => (
  <ADWorkplaceTaskForm {...props} forwardedRef={ref} />
));
